<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.contractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag-option-is-value-text
                @change="conCodeChanged"
                v-decorator="['conCode', validatorRules.conCode]"
                dict="efs_md_contract as t1,name,code,con_version=(select max(con_version) from efs_md_contract where t1.code=code) and del_flag='N' and valid_flag='Y'" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="批次编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag-option-is-value-text :disabled="isBreedBatchCodeDisabled" v-decorator="['breedBatchCode', validatorRules.breedBatchCode]" dict="efs_md_breed_batch,name,code" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="isValidFlagDisabled" type="list" v-decorator="['validFlag',{'initialValue':'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>

  import { getAction, httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import JSearchSelectTagOptionIsValueText from '@/components/dict/JSearchSelectTagOptionIsValueText'

  export default {
    name: "EfsMdContractPriceListModal",
    components: {
      JDictSelectTag,
      JSearchSelectTag,
      JSearchSelectTagOptionIsValueText
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules: {
          conCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheContractCode')},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_contract_price_list', 'con_code', value, this.model.conCode, callback)},
            ]
          },
          breedBatchCode: {
            rules: [
              { required: true, message: '请输入批次编码!'},
            ]
          },
        },
        url: {
          add: "/contractPriceList/efsMdContractPriceList/add",
          edit: "/contractPriceList/efsMdContractPriceList/edit",
          queryByContractCodeWithMaxversion: "/contractManage/efsMdContract/queryByContractCodeWithMaxversion"
        },
        isBreedBatchCodeDisabled: true,
        isValidFlagDisabled: true,
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'conCode','breedBatchCode','validFlag'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.form.resetFields();
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'conCode','breedBatchCode','validFlag'))
      },
      conCodeChanged(param){
        getAction(this.url.queryByContractCodeWithMaxversion, { code: param }).then(res => {
          if (res.success) {
            // this.form.resetFields()
            this.form.setFieldsValue({
              // conCode: res.result.code,
              breedBatchCode: res.result.breedBatchCode,
            })
          } else {
            this.$message.warning(res.message)
          }
        })
      }

    }
  }
</script>